/* Set */
 const setCookie = (name, value, days = 7, path = '/') => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=' + path
}

/* Get */
const getCookie = (name) => {
    return document.cookie.split('; ').reduce((r, v) => {
        const parts = v.split('=')
        return parts[0] === name ? decodeURIComponent(parts[1]) : r
    }, '')
}

//-----------------hp_subscription-------------------
export const hpSubscription = () => {
	if(!getCookie('hp_subscription_2068')){
        $('.hp_subscription').addClass('show-hp_subscription');
    }

    $('.hp_subscription-btn').on('click', function(e){
        setCookie('hp_subscription_2068', true, 365);
        $('.hp_subscription').removeClass('show-hp_subscription');
    });

    $('.hp_subscription-notnow').on('click', function(){
        setCookie('hp_subscription_2068', true, 7);
        $('.hp_subscription').removeClass('show-hp_subscription');
    });
};